export const hotelRegulationsText = {
  "en-US": `
<b>Dear Guest,</b>

We’re thrilled to have you stay with us at <b>A&G</b>, where we strive to create a <b>cozy, fun, and safe</b> environment for all our guests. To help us maintain this atmosphere, we kindly ask that you <b>follow the house rules</b> outlined below. These guidelines ensure <b>everyone’s comfort, safety, and enjoyment,</b while also helping us preserve the quality of our property.
<b>Important Notice: Adults-Only Property (18+)</b>

A&G is an <b>adults-only property. Children and minors (under 18 years old) are not permitted.</b>

<b>House Rules:</b>

1.	<b>Security Deposit:</b>
A <b>security deposit of 100 CHF</b> is required for every reservation. This deposit will be held on your credit card and <b>released within one week after checkout,</b> provided there are no damages or issues.

2.	<b>Self-Check-In:</b>
A&G operates with a <b>self-check-in system.</b> To access your room, please complete the <b>Self-Check-In Form</b> sent with your booking confirmation and ensure that your <b>payment is processed.</b> We are <b>not responsible for any access issues</b> if these steps are not completed.

3.	<b>Communication & Services:</b>
All communication, <b>except in emergencies,</b> should be conducted <b>through the our guest portal or by whatsapp.</b> Rooms are <b>cleaned and prepared before your arrival,</b> but the <b>room rate does not include cleaning services during your stay</b>.

4.	<b>No Parties or Events:</b>
A&G is a <b>social yet peaceful</b> place. <b>Parties and events that cause noise or disturbances are strictly prohibited</b> to maintain a pleasant environment for all guests.

5.	<b>No Smoking:</b>
Smoking is <b>prohibited indoors</b>. Please use <b>designated outdoor smoking areas</b> and dispose of cigarette butts responsibly.

6.	<b>No Pets:</b>
Although we love animals, <b>A&G is a pet-free property</b> to ensure a <b>clean and allergen-free</b> environment for all guests.

7.	<b>Found Items:</b>
If you <b>leave anything behind,</b> it will be kept in our <b>lost and found.</b> Please contact us to arrange a collection, as our office may not always be open.

8.	<b>No Unregistered Guests:</b>
For <b>security and comfort, only guests listed in the booking are allowed on the premises.</b>

9.	<b>No Food or Drinks in Bedrooms:</b>
Please <b>enjoy your meals and drinks in the common areas</b> to prevent spills and stains in the bedrooms.

10.	<b>Quiet Hours:</b>
To ensure a <b>restful environment</b>, quiet hours are:
  •  <b>10:00 PM – 7:00 AM</b>
  •  <b>12:00 PM – 1:00 PM</b>
  •  <b>Sundays and public holidays</b> are also considered <b>quiet times.</b>

11.	<b>Check-In and Check-Out Times:</b>
Please <b>respect our check-in and check-out times</b> to help us manage cleaning schedules and prepare for incoming guests.

12.	<b>Key Care:</b>
Please take care of your room key. <b>Lost keys will incur a replacement fee of 500 CHF.</b>

13.	<b>Respect for Furniture and Property:</b>
<b>Treat the property with care</b> and report any damages. If damages <b>exceed the security deposit</b>, additional charges will apply.

14.	<b>No Rearranging Furniture:</b>
Please <b>do not move or rearrange furniture</b>, as this can cause damage and create extra work for our team.

15.	<b>Dishes:</b>
We kindly ask that you <b>wash your dishes before departure</b> to help us maintain a clean and ready space for the next guest.

16.	<b>Trash Disposal:</b>
Please <b>take out your trash before checking out</b> to keep the hostel tidy.

17.	<b>No Illegal Substances:</b>
The <b>use or possession of illegal substances is strictly forbidden</b> to ensure a safe and legal environment for all guests.

18.	<b>No Prostitution:</b>
<b>Prostitution is strictly prohibited</b> at A&G. <b>Violation of this rule will result in a 1,000 CHF fine and a report to the authorities.</b>

By following these rules, you’re helping us keep <b>A&G</b> a <b>welcoming, enjoyable, and safe</b> place for everyone. We <b>appreciate your cooperation</b> and hope you have a <b>fantastic stay!</b>

<b>Warm regards,
The A&G Team</b>
`};
